import { render } from "./ContractModelUpdate.vue?vue&type=template&id=145a1178&scoped=true"
import script from "./ContractModelUpdate.vue?vue&type=script&lang=js"
export * from "./ContractModelUpdate.vue?vue&type=script&lang=js"

import "./ContractModelUpdate.vue?vue&type=style&index=0&id=145a1178&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-145a1178"]])

export default __exports__